import { useEffect, useState } from "react";

/**
 * Bronze 2px scroll progress bar. Fixed to the very top of the viewport
 * above every other layer, growing from 0% to 100% width as the document
 * scrolls. Updates on every scroll/resize event with no CSS transition
 * so the line tracks the cursor in real time. Hidden on documents short
 * enough that nothing scrolls (otherwise the bar would sit at 0% the
 * whole time and read as visual noise).
 */
const ScrollProgress = () => {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const recompute = () => {
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - doc.clientHeight;
      if (scrollable <= 1) {
        setVisible(false);
        setProgress(0);
        return;
      }
      setVisible(true);
      const pct = Math.min(100, Math.max(0, (window.scrollY / scrollable) * 100));
      setProgress(pct);
    };
    recompute();
    window.addEventListener("scroll", recompute, { passive: true });
    window.addEventListener("resize", recompute);
    return () => {
      window.removeEventListener("scroll", recompute);
      window.removeEventListener("resize", recompute);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      aria-hidden
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        height: 2,
        width: `${progress}%`,
        background: "#997E54",
        zIndex: 9999,
        pointerEvents: "none",
        // No transition: width tracks scroll cursor in real time.
        transition: "none",
      }}
    />
  );
};

export default ScrollProgress;
